import { InputProps } from "types/dom";


type DecimalControlInputProps = InputProps & {
  allowDecimal?: boolean;
  maxDecimalPlaces?: number;
};

export default function NumberOnlyInput ({ allowDecimal = false, maxDecimalPlaces = 2, ...otherProps }: DecimalControlInputProps) {
  // Editing and navigation keys stay usable so keyboard users can move around and correct values
  const allowedKeys = [ "Backspace", "Delete", "Enter", "Tab", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End", ...(allowDecimal ? [ "." ] : []) ];

  const handleKeyDown = (event: { key: string; ctrlKey?: boolean; metaKey?: boolean; currentTarget: { value: string; }; preventDefault: () => void; }) => {
    if (event.ctrlKey || event.metaKey) {
      return;
    }
    if (!allowedKeys.includes(event.key) && !/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
    if (/[0-9]/.test(event.key) && event.currentTarget.value.split(".")[1]?.length >= maxDecimalPlaces) {
      event.preventDefault();
    }
  };

  return <input
    type="number"
    onKeyDown={handleKeyDown}
    {...otherProps}
  />;
}